import IMask from 'imask';
import './Field';

if (typeof window.IMask === 'undefined') {
    window.IMask = IMask;
}

if (typeof window.Phone === 'undefined') {
    window.Phone = class Phone extends window.Field {
        constructor(input) {
            super(input);

            this.mask = window.IMask(input, {
                mask: '+{7} (000) 000-00-00',
            });
            input.imask = this.mask;
        }
    };
}
